import React, { Component } from 'react';
import Noimage from '../../../webroot/images/noimage.jpg';
import CheckBox from '../../elements/CheckBox';
import ModalPopup from '../../elements/Popup';
import ShareDetails from './ShareDetails';
import AddBuyerLead from './Addbuyerlead';
import CertificationEdit from './Certificationedit';
import MakeFeatured from './MakeFeatured';
import AddToStock from './AddToStock';
import MakeClassified from './MakeClassified';
import MakeClassifiedStock from './MakeClassifiedStock';
import MakeBursa from './MakeBursa';
import MakeBumpUp from './MakeBumpUp';
import ViewHistory from './ViewHistory';
import DeleteReason from './DeleteReason';
import Carousel from './ListingCarousal';
import RejectedCarousel from './RejectedListingCarousal';
import ButtonGroup from '../../elements/ButtonGroup';
import TagPhotos from './TagPhoto';
import ToolTip from './../../elements/Tooltip'
import MasterService from './../../../service/MasterService';
import { toast } from 'react-toastify';
import {NumericFormat} from 'react-number-format';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import secureStorage from './../../../config/encrypt';
import { BUMP_UP_LIMIT, CURRENCY_SYMBOL, WEBSITE_NAME, SITE_ID_DURING_CLASSIFIED } from './../../../config/constant';
import { InventoryService } from '../../../service';
class SearchResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showgallerymodal: false,
            showAddLeadPopup: false,
            showCertificationEditPopup: false,
            showFeaturedPopup: false,
            showClassifiedPopup: false,
            showBursaPopup:false,
            showDeleteReasonPopup: false,
            showAddToStockPopup: false,
            showSharePopup: false,
            showBumpUpPopup:false,
            showViewHistory:false,
            removeReasonList: [],
            carouselSlidesData: [],
            imageTagListDpd: [],
            carouselSlidesRejectedImageData:[],
            carId: 0,
            car_id_hash: '',
            currentIndex: 0,
            min_car_price: 1000,
            featuredVal: '',
            editPrice: {},
            updateCarPriceParams: {},            
            statusClassname: {
                'active': 'nav-item active',
                'removed': 'nav-item',
                'all': 'nav-item'
            },
            showViewPhoto: true,
            showRejectedPhoto: false,
            showTaggingPhoto: false,
            showBumpUpFlag: true,
            totalBumpUp: 0 ,
            bumpUpExpiryMin:null,
            site_name_list: [],
            stockCategory:this.props.stockCategory || 1,
            bump_up_flag_setting_from_master_api:0,
            site_id:''
        }
    }

    componentDidMount = () => {
        this.getStockRemoveReason();
        this.getbumpUpStatus();
        this.getImageTagList();
        this.getMasterData();
    }

    getMasterData = () => {
        MasterService.getMasters(['bump_up_flag','min_car_price','site_name_list']).then((response) => {
            if (response.status == 200 && response.data.status == 200 && response.data.data) {
                if(response.data.data.min_car_price) {
                    this.setState({
                        min_car_price: response.data.data.min_car_price,
                        bump_up_flag_setting_from_master_api: response.data.data.bump_up_flag,
                        site_name_list: response.data.data.site_name_list
                    })
                }
            } else if (response.status == 401 && response.data.status == 401) {
                this.setState({ redirect: true })
            }
        }).catch((error) => {
        });

    }
    getbumpUpStatus = async () => {
        var thisObj = this;
        MasterService.get('inventory/inventory/bump_up_status')
            .then(function (response) {
                if (response.data.status == 200 && response.data.data.length) {
                    let total_bump_up = response.data.data.length;
                    let bump_up_expiry_min = response.data.data[0].min;
                    let show_bump_up = (total_bump_up < BUMP_UP_LIMIT)?true:false;   
                    thisObj.setState({ showBumpUpFlag: show_bump_up,totalBumpUp: total_bump_up,bumpUpExpiryMin:bump_up_expiry_min});
                }else{
                    thisObj.setState({ showBumpUpFlag: true});
                }
            })
            .catch(function (response) {
            });
    }
    getImageTagList=()=> {   
        var postObj = {};     
        MasterService.post('inventory/inventory/image_tagging_list',postObj)
            .then( (response) => {               
                if (response.data.status == 200) {                    
                    if (response.data.data.length) {
                        this.setState({ imageTagListDpd: response.data.data },()=>{});
                    }
                }
            })
            .catch(function (response) {
            });
    }
    getUsedCarImageList = async (stock_used_car_id) => {       
        var thisObj = this;
        var postObj = { stock_used_car_id: stock_used_car_id,image_status:'1' };
        MasterService.post('inventory/inventory/usedcarimagelist', postObj)
            .then(function (response) {  
                if (response.data.status == 200) {                    
                    let carImageListArr = [];
                    response.data.data.forEach(function (result) {
                        let imageUrl = result.url;
                        let tempCarImagedetail = {
                            content: <div><img src={imageUrl+'?resize=620x400'} alt="car-img" /></div>,
                            alt: 'Front',
                            src: imageUrl+'?resize=100x60',
                            comment:result.comment,
                            tag_id:result.tag_id,
                            id:result.id
                        }
                        carImageListArr.push(tempCarImagedetail);
                    });
                    thisObj.setState({
                        carouselSlidesData: carImageListArr
                    });
                }
            })
            .catch(function (response) {
            });
    }
    getUsedCarRejectedImageList = async (stock_used_car_id) => {       
        var thisObj = this;
        var postObj = { stock_used_car_id: stock_used_car_id,image_status:'0' };
        MasterService.post('inventory/inventory/usedcarimagelist', postObj)
            .then(function (response) {                  
                if (response.status == 200) {                    
                    let carImageListArr = [];
                    response.data.data.forEach(function (result) {
                        let imageUrl = result.url;
                        let reject_comment_obj=JSON.parse(result.reject_comment);
                        let reject_comment=[];
                        if(reject_comment_obj && reject_comment_obj.length){
                            reject_comment_obj.forEach(reject_comment_obj_data => {                            
                                    reject_comment.push(reject_comment_obj_data.issue_label);                                                                
                            });    
                        }
                        let tempCarImagedetail = {
                            content: <div><img src={imageUrl+'?resize=620x400'} alt="car-img" /></div>,
                            alt: 'Front',
                            src: imageUrl+'?resize=100x60',
                            rejected_reason:reject_comment,
                            comment:result.comment,
                            tag_id:result.tag_id
                        }
                        carImageListArr.push(tempCarImagedetail);
                    });                    
                    thisObj.setState({
                        carouselSlidesRejectedImageData: carImageListArr                        
                    },() => {
                        console.log(thisObj.state.carouselSlidesRejectedImageData);
                    });
                }
                console.log('response.data.data', response.data.data);
            })
            .catch(function (response) {
            });
    }
    showDevInfo = (event) => {
        if (event.target == event.currentTarget) this.setState({ showDevCount: (this.state.showDevCount || 0) + 1 });
    }
    showModal = (type, carId, index) => {
        this.setState({ [type]: true, carId: carId, currentIndex: index });
    }
    showCertificationModal = (type, carId, index, car_id_hash) => {
        this.setState({ [type]: true, carId: carId, currentIndex: index, car_id_hash: car_id_hash });
    }
    pushToEs = (carOne, index) => {
        this.setState({loading: 'loading'});
        MasterService.post('inventory/cron/es_push_invnetory', { "dccarid": carOne.id })
            .then((response) => {
                this.setState({loading: ''});
                console.log("/es_push_invnetory ---> stock_id:", carOne.id, " || response.data.data", response.data.data);
            })
            .catch((error) => {
                this.setState({loading: ''});
                console.error("/es_push_invnetory ---> stock_id:", carOne.id, " || error", error);
            });
    }
    showFeatureModal = (type, carId, featuredVal, index, isclassified) => {
        let updateFeature = '' , updateClassified = '';
         if (featuredVal == 1) {
            updateFeature = 'false';
        }
        else if (featuredVal == 0) {
            updateFeature = 'true';
        }
        if (isclassified == 1) {
            updateClassified = 'true';
        }
        else if (isclassified == 0) {
            updateClassified = 'false';
        }
        this.setState({ [type]: true, carId: carId, featuredVal: updateFeature,currentIndex: index,classifiedVal: updateClassified });
    }
    showBursaModal = (type, carId, e, index,ispremium,is_bump_enable,site_id) => {
        //alert(`${ispremium} ${is_bump_enable}`);
        let updateBursa = '';
        if (ispremium == 1)
            ispremium = 'true';
        else
            ispremium = 'false';
        if (e.target.checked == true) {
            updateBursa = 'true';
        } else {
            updateBursa = 'false';
        }
        console.log("updateBursa----",updateBursa);
        this.setState({ [type]: true, carId: carId, bursaVal: updateBursa,  currentIndex: index });
    }
    showClassifiedModal = (type, carId, e, index,ispremium,is_bump_enable,site_id,is_bursa) => {
        //alert(`${ispremium} ${is_bump_enable}`);
        let updateClassified = '';
        if (ispremium == 1)
            ispremium = 'true';
        else
            ispremium = 'false';
        if (e.target.checked == true) {
            updateClassified = 'true';
        } else {
            updateClassified = 'false';
        }
        this.setState({ [type]: true, carId: carId, classifiedVal: updateClassified, is_bursa : is_bursa ,featuredVal: ispremium,is_bump_enable: is_bump_enable, currentIndex: index ,siteid: (site_id ? (site_id.split(',')).map((v)=>v) : []) });
    }

    showBumpUpFieldModal = (type, carOne, index, is_bump_enable) => {
        let isbumup = '';
        if (is_bump_enable == '0' ){
            isbumup = 'true';}
        else{
            isbumup = 'false';
        }
        this.setState({ [type]: true, carId: carOne.id, carOne: { ...carOne }, is_bump_enable: isbumup, currentIndex: index });
    }

    
    showgallaryModal = async (carId) => {
        this.changeTabs(1);
        await this.getUsedCarImageList(carId);
        await this.getUsedCarRejectedImageList(carId);
        this.setState({ showgallerymodal: true });
    }
    closeModal = () => {
        this.setState({ showgallerymodal: false, showAddLeadPopup: false, showCertificationEditPopup: false, showFeaturedPopup: false, showClassifiedPopup: false, showBursaPopup: false, showDeleteReasonPopup: false, showAddToStockPopup: false,showBumpUpPopup: false,showViewHistory:false, showSharePopup: false} );
    }

    showCarPrice = (id) => {

        let editPriceArr = { ...this.state.editPrice };
        // eslint-disable-next-line array-callback-return
        Object.keys(editPriceArr).map(function (key, index) {
            editPriceArr[key] = 'hide';
        });
        editPriceArr['car_' + id] = 'show';

        this.setState({
            editPrice: {
                ...editPriceArr
            }
        }, () => {

        });
    }
    hideCarPrice = (id) => {        
        let editPriceArr = { ...this.state.editPrice };        
        this.setState({
            editPrice: {
                editPriceArr,
                ['car_' + id]: 'hide'
            }
        }, () => {

        });
    }
    changeCarPrice = (id, e) => {
        this.setState({
            updateCarPriceParams: {
                stock_used_car_id: id,
                car_price: e.target.value.replace(/\./g,'')
            }
        });
    }
    getStockRemoveReason() {        
        var thisObj = this;
        MasterService.get( 'core/commonservice/stock_remove_reason')
            .then(function (response) {
                if (response.data.status == 200) {
                    if (response.data.data.length) {
                        thisObj.setState({ removeReasonList: response.data.data });
                    }
                }
            })
            .catch(function (response) {
            });
    }

    saveUsedcarPrice = async (car, index) => {
        const id = car.id;

        if (this.state.updateCarPriceParams.stock_used_car_id == id && this.state.updateCarPriceParams.car_price >= this.state.min_car_price) {
            let postObj = {
                car_price: this.state.updateCarPriceParams.car_price,
                stock_used_car_id: this.state.updateCarPriceParams.stock_used_car_id,
                version_id: car.version_id,
                uc_colour_id: 0,
                km_driven: car.km_driven,
            };

            try {
                const carDetailsResponse = await InventoryService.getCarDetail({
                    car_hash: car.car_id_hash
                });

                if (
                    carDetailsResponse?.status === 200 &&
                    carDetailsResponse?.data?.status === 200
                ) {
                    const carDetails = carDetailsResponse.data.data || {};
                    if (Object.keys(carDetails).length > 0) {
                        postObj.uc_colour_id = carDetails.uc_colour_id || 0;
                    }
                }

                const response = await MasterService.post(
                    'inventory/inventory/updateusedstockcar',
                    postObj
                );

                if (response?.data?.status === 200) {
                    toast.success(response.data.message);
                    this.updateListData(
                        { car_price: this.state.updateCarPriceParams.car_price },
                        index
                    );
                    this.hideCarPrice(id);
                } else {
                    toast.error(response?.data?.message || 'Something went wrong');
                }
            } catch (error) {
                toast.error('Failed to update car price');
            }
        } else {
            toast.error(this.props.t('listInventory.validation_car_price_min', { min_car_price: this.state.min_car_price }));
        }
    }

    statusClickHandler = (type, statusVal) => {
        this.props.handleStatusChange(statusVal);
        this.setState({
            statusClassname: {
                'active': 'nav-item',
                'removed': 'nav-item',
                'all': 'nav-item',
                [type]: 'nav-item active'
            }
        })
    }    

    handleRemovedCar = () =>{
        this.props.handleRemovedCar(this.state.currentIndex);
    }

    updateListData = (updatedObj, index) => {        
        this.props.updateListData(updatedObj, index);
    }

    __changeToRupiah(price){
        var rev     = parseInt(price, 10).toString().split("").reverse().join("");
        var rev2    = "";
        for(var i = 0; i < rev.length; i++){
            rev2  += rev[i];
            if((i + 1) % 3 === 0 && i !== (rev.length - 1)){
                rev2 += ".";
            }
        }
        return CURRENCY_SYMBOL + rev2.split("").reverse().join("");
    }

    getExpiryTime(expiry_date) {
        let currentDate = new Date();
        let expirydate = new Date(expiry_date);
        var diff = (expirydate.getTime() - currentDate.getTime()) / 1000;
        diff /= 60;
        let min = Math.abs(Math.round(diff));
        return (min+1)
    }

    changeTabs = (tab_id) =>{
        this.setState({
            showViewPhoto :false,
            showRejectedPhoto:false,
            showTaggingPhoto: false
        })
        if(tab_id==1){
            this.setState({
                showViewPhoto :true
            })
            
        }else if(tab_id==2){
            this.setState({
                showRejectedPhoto :true
            })
        }else if(tab_id==3){
            this.setState({
                showTaggingPhoto :true
            })
        }
    }
        dateTimeFormate(bumpupDate) {
            let date = new Date(bumpupDate);
            let formateTime = ""; //date.getHours() >= 12 ? " PM" : " AM";
            let month = ("00" + (date.getMonth() + 1)).slice(-2) + "/"; 
            let day =  ("00" + date.getDate()).slice(-2) + "/";
            let year =  date.getFullYear()+" ";
            let hours = ("00" + date.getHours()).slice(-2)+ ":";
            let min = ("00" + date.getMinutes()).slice(-2) ;
            let dateStr = month + day + year + hours + min;
            return dateStr +formateTime;
        }

    render() {
        // let expiryFlag = this.state.expiryFlag;//need to remove var not in use 
        // let isBumpUpFlag = this.state.isBumpUpFlag;//need to remove var not in use 
        // let defaultExpiryMin = this.state.expiryMin;//need to remove var not in use 
        let viewPhotosLength=this.state.carouselSlidesData.length;
        let rejectedPhotosLength=this.state.carouselSlidesRejectedImageData.length;
        let site_name = this.state.site_name_list;
        let btngroup=[];
        if(viewPhotosLength>0){
            btngroup=[{
                label: 'View Photos',
                type: 'button',
                class: 'btn btn-default btn-sm',
                selectedClass: 'btn btn-primary btn-sm',
                key: "1",
                id: "1"
              }];
        }
        if(rejectedPhotosLength>0){
            let tempBtn=  {
                label: 'Rejected Photos',
                type: 'button',
                class: 'btn btn-default btn-sm',
                selectedClass: 'btn btn-primary btn-sm',
                key: "2",
                id: "2"
              }
              btngroup.push(tempBtn);
        }
        if(viewPhotosLength>0){
            let tempBtn={
                label: 'Tag photos',
                type: 'button',
                class: 'btn btn-default btn-sm',
                selectedClass: 'btn btn-primary btn-sm',
                key: "3",
                id: "3"
              };
              btngroup.push(tempBtn);
        }
    //   let expiryTime =  this.state.bumpUpExpiryMin + " Mins";//need to remove var not in use
    //   let expirymsg = this.props.t('listInventory.bump_up_expiry_msg');//need to remove var not in use
      let BUMP_UP_ENABLE= this.state.bump_up_flag_setting_from_master_api;
      let stockCategory = this.state.stockCategory;
      let edit_url = 'add-stock';
      let IsBursa = secureStorage.getItem('IsBursa') || 0;
      if(stockCategory==3) edit_url = 'add-truck';
        return (
            <div className={`card ${this.state.loading}`}>
                <div>
                    <ul className="list-inline nav-tabs" onClick={this.showDevInfo}>
                        <li className={this.state.statusClassname.active} onClick={() => { this.statusClickHandler('active', [1]) }}>
                            <div>
                                {this.props.t('listInventory.active_status')}<span>({this.props.statusCount.active})</span>
                            </div>
                        </li>
                        <li className={this.state.statusClassname.removed} onClick={() => { this.statusClickHandler('removed', [2]) }}>
                            <div>
                                {this.props.t('listInventory.removed_status')}<span>({this.props.statusCount.removed})</span>
                            </div>
                        </li>
                        <li className={this.state.statusClassname.all} onClick={() => { this.statusClickHandler('all', [1, 2]) }}>
                            <div>
                                {this.props.t('listInventory.all_status')}<span>({this.props.statusCount.all})</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <ul className="car-list">
                        {
                            this.props.stockData.length == 0 && this.props.firstLoad ? 
                                <li><h6 className="text-center text-danger text-bold">{this.props.t('listInventory.loading')}</h6></li> 
                                : this.props.stockData.length == 0 ? 
                                    <li><h6 className="text-center text-danger text-bold">{this.props.t('listInventory.no_record_found')}</h6></li> 
                                : ''
                        }
                        {this.props.stockData.map((car, index) =>
                            <li key={car.id}>
                                <div className="wrap row">
                                    <div className="col-sm-2">
                                        <div className="img-box">

                                            {car.car_profile_image ? (
                                                <a href={() => false} onClick={() => { this.showgallaryModal(car.id) }}>
                                                    <div>
                                                        <div className="img_thumb"><img src={car.car_profile_image+'?resize=215x160'} alt=''/></div>
                                                        <span className="link">{this.props.t('listInventory.view_photos')}</span>
                                                    </div>
                                                </a>
                                            ) : (
                                                    <Link to={`/${edit_url}/${car.car_id_hash}`}>
                                                        <div className="img_thumb"><img src={Noimage} alt=""></img></div>
                                                        {/* <span className="link">Click to upload</span> */}
                                                    </Link>
                                                )}

                                        </div>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="row">
                                            <div className="col-sm-6 col-md-7">
                                                <h2 className="carname">
                                                {car.car_status == '1'? 
                                                    <Link to={`/${edit_url}/${car.car_id_hash}`}>{car.make} {car.modelVersion} {" (Car Id:" + car.id + ")"}</Link>:<React.Fragment>{car.make} {car.modelVersion}</React.Fragment>
                                                }  
                                                &nbsp;{car.qc_status_txt ?
                                                        <>
                                                        <span style={{ padding: "0.3em 0.7em 0.3em 0.4em" }} className="label red-status"> {car.qc_status_txt}</span>
                                                        &nbsp;<ToolTip id="ask" title={car.qc_status_comment && car.qc_status_comment.join(',')} ><i className="ic-error text-light"></i></ToolTip></>
                                                        : ''}
                                               &nbsp;{(car.ispremium == 1) && <span style={{padding: "0.3em 0.7em 0.3em 0.4em"}} className="label green-status"><i className="ic-cd-featured"></i> Featured</span> }
                                               &nbsp; {car.certification_status != "0" && <span style={{padding: "0.3em 0.7em 0.3em 0.4em"}} className="label orange-status"><i className="ic-cd-featured"></i> Inspected</span>}
                                                {this.state.showDevCount>=3 && "   (carId:"+car.id+")"}
                                                {this.state.showDevCount>=3 &&  <Link to="#" onClick={() => this.showModal('showViewHistory',car.id, index)}> &nbsp;&nbsp;{this.props.t('viewHistory.view_history')}</Link>}
                                                {this.state.showDevCount>=3 &&  <Link to="#" onClick={() => this.pushToEs(car, index)}> &nbsp;&nbsp;{this.props.t('ES_Push')}</Link>}
                                                </h2>
                                                <ul className="list-inline stock-listed">
                                                    <li>{car.reg_car_city_name}</li>
                                                    <li>{this.props.t('listInventory.listed_on')}: {car.listed_on}</li>
                                                    { BUMP_UP_ENABLE=='1' && car.bump_up == '1' && car.bump_up_date ? <li>{this.props.t('listInventory.bumpup_date')}: {this.dateTimeFormate(car.bump_up_date)}</li>: '' }
                                                </ul>

                                                <ul className="row car-specs">
                                                    <li className="col-xs-6 col-sm-6  col-md-4 col-lg-3 small"><i className="ic-cd-kilometer icons-normal"></i>{car.km_driven}  {this.props.t('listInventory.km')}</li>
                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small">
                                                        <i className="ic-cd-year icons-normal"></i>{car.display_reg_date}
                                                    </li>
                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-cd-owner icons-normal"></i>{car.display_owner_type}</li>
                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-cd-fuel icons-normal"></i>{(car.fuel_type)?car.fuel_type:'N/A'}</li>
                                                    {car.reg_no &&
                                                        <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-rc-file icons-normal"></i>{car.reg_no}</li>
                                                    }

                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-cd-Transmission icons-normal"></i>{car.transmission}</li>
                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-colors icons-normal"></i>{car.uc_colour}</li>
                                                    <li className="col-xs-6 col-sm-6 col-md-4 col-lg-3 small"><i className="ic-engine icons-normal"></i>{(car.engine_capacity)?car.engine_capacity:'N/A'}</li>
                                                </ul>
                                            </div>
                                            <div className="col-sm-2 col-md-2 text-center">
                                                {stockCategory == 1 &&
                                                    (car.leadCount == 0 ? <div className="lead-circle">
                                                    <div className="pie_progress__number">{car.leadCount}</div>
                                                    <div className="pie_progress__label">{this.props.t('listInventory.total_lead')}</div>
                                                    </div> :
                                                    <Link to={`/lead/${car.car_id_hash}`} className="lead-circle">
                                                    <div className="pie_progress__number">{car.leadCount}</div>
                                                    <div className="pie_progress__label">{this.props.t('listInventory.total_lead')}</div>
                                                    </Link>)
                                                }
                                            </div>
                                            <div className="col-sm-4 col-md-3">
                                                <div className="mrg-b15">
                                                    <strong>{this.props.t('listInventory.retail_price')}
                                                    <span className=" text-primary mrg-l5" id={`show_retail_price_${car.id}`} > {this.__changeToRupiah(car.car_price)}</span></strong>
                                                    <ToolTip  title={this.props.t('listInventory.edit')} ><span className="editBtn btn btn-link" onClick={() => { this.showCarPrice(car.id) }}><i className="ic-createmode_editedit"></i></span></ToolTip>
                                                    <div className={`editprice hide ${this.state.editPrice['car_' + car.id]}`}>
                                                        <div className="input-group form-group">
                                                            {/* <InputField
                                                                inputProps={{
                                                                    id: "edit_retail_price",
                                                                    type: "number",
                                                                    placeholder: this.props.t('listInventory.enter_price'),
                                                                    name: "price",
                                                                    autocompleate: "off",
                                                                }}
                                                                onChange={(e) => { this.changeCarPrice(car.id, e) }}
                                                            /> */}
                                                            <NumericFormat thousandSeparator="." decimalSeparator="," maxLength="15"  name="edit_retail_price" onChange={(e) => { this.changeCarPrice(car.id, e) }}/>
                                                            <div className="input-group-append">
                                                                <button type="button" className="btn btn-primary" onClick={() => this.saveUsedcarPrice(car, index)}>{this.props.t('listInventory.save')}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {car.car_status == '1' && stockCategory == 1 ?
                                                <div className="inlinecheck classifiedCheck">
                                                    <CheckBox
                                                        id="classifiedStock"
                                                        type="checkbox"
                                                        name="classifiedStock"
                                                        value="1"
                                                        label={this.props.t('listInventory.classified')}
                                                        checked={(car.isclassified == 1) ? true : false}
                                                        onChange={(e) => this.showClassifiedModal('showClassifiedPopup', car.id, e, index,car.ispremium,car.is_bump_enable,car.site_id,car.is_bursa)}
                                                    />
                                                    <ToolTip id="ask" title={this.props.t('listInventory.classified_icon_msg',{website: WEBSITE_NAME})} ><i className="ic-error text-light"></i></ToolTip>
                                                </div> : ''}

                                                {car.car_status == '1' && stockCategory == 1 && IsBursa == 1?
                                                <div className="inlinecheck">
                                                    <CheckBox
                                                        id="bursa"
                                                        type="checkbox"
                                                        name="bursa"
                                                        value="1"
                                                        label={this.props.t('listInventory.bursa')}
                                                        checked={(car.is_bursa == 1) ? true : false}
                                                        onChange={(e) => this.showBursaModal('showBursaPopup', car.id, e, index,car.ispremium,car.is_bump_enable,car.site_id)}
                                                    />
                                                    <ToolTip id="ask" title={this.props.t('listInventory.bursa_icon_msg')}><i className="ic-error text-light"></i></ToolTip>
                                                </div> : ''}

                                                {car.show_weburl == 1 && stockCategory == 1 ?
                                                <div>
                                                    <span className="f12">{this.props.t('listInventory.view_on')}: </span>
                                                    {/* <a href="#" title="Website URL" className="mrg-r5">
                                                        <i className="source-icon website"></i>
                                                    </a> */}


                                                    {
                                                        (process.env.REACT_APP_CONFIG_FILE_NAME === 'zw-sg' || process.env.REACT_APP_CONFIG_FILE_NAME === 'zw-my')
                                                        ?
                                                            <a href={car.web_url} target="_blank" rel="noreferrer" title={this.props.t('listInventory.website_url')} className="mrg-r5">
                                                                <i className="source-icon zigwheel"></i>
                                                            </a>
                                                        :
                                                            (
                                                                Array.isArray(car.web_url)?
                                                                <>
                                                                {car.web_url.map((urlObj) => (
                                                                    <a href={urlObj.url} key={urlObj.key} target="_blank" rel="noreferrer" title={this.props.t('listInventory.website_url')} className="mrg-r5">
                                                                        <i className={'source-icon '+ urlObj.css_class}></i>
                                                                    </a>
                                                                ))}
                                                                </>
                                                                :
                                                                <a href={car.web_url} target="_blank" rel="noreferrer" title={this.props.t('listInventory.website_url')} className="mrg-r5">
                                                                    <i className="source-icon oto"></i>
                                                                </a>
                                                            )
                                                    }
                                                    
                                                </div> : '' }
                                                {car.certification_url && stockCategory == 1 && car.certification_status == '1' ?
                                                    <div>
                                                        <a href={car.certification_url} target="_blank" rel="noreferrer" title={this.props.t('listInventory.inspected_url')} className="mrg-r5">
                                                            <span>{this.props.t('listInventory.inspected_url')}</span>
                                                        </a>

                                                    </div> : ''}

                                               {/* {
                                                car.is_bump_enable ?                                          
                                                <p className="mrg-t15 text-danger"><span>{this.props.t('listInventory.bump_up_expiry_msg')}:</span>{this.getExpiryTime(car.bump_up_expiry_date)} Mins</p>
                                                : ''
                                               } */}
                                            </div>
                                            <div className="col-sm-12 actionbtn">
                                                <div className="btn-toolbar clearfix" data-gs-csstooltip-wrapper="tooltip">
                                                    {car.car_status == '1'? 
                                                        <div>
                                                            <div aria-label="First group" role="group" className="btn-group mrg-r10">                                                                
                                                            {car.certification_status == "0" &&
                                                                <Link to={`/${edit_url}/${car.car_id_hash}`}><button type="button" className="btn btn-default mrg-r10" title={this.props.t('listInventory.edit')}><i className="ic-createmode_editedit"></i></button></Link>
                                                            }
                                                                {car.certification_status == "1" &&
                                                                    <button type="button" className="btn btn-default mrg-r10" onClick={() => this.showCertificationModal('showCertificationEditPopup', car.id, index, car.car_id_hash)} title={this.props.t('listInventory.edit')}><i className="ic-createmode_editedit"></i></button>
                                                                }
                                                                <button type="button" className="btn btn-default" onClick={() => this.showModal('showDeleteReasonPopup', car.id, index)} title={this.props.t('listInventory.remove')}><i className="ic-delete"></i></button>
                                                            </div>
                                                            {stockCategory == 1 ?
                                                                <button type="button" className="btn btn-default mrg-r10" onClick={() => this.showFeatureModal('showFeaturedPopup', car.id, car.ispremium, index, car.isclassified)} title={car.ispremium == 1 ? this.props.t('listInventory.un_feature') : this.props.t('listInventory.make_feature')} ><i className={car.ispremium == 1 ? "ic-cd-un-featured" : "ic-cd-featured"}></i></button>
                                                                : ''}
                                                            {(BUMP_UP_ENABLE == "1" && stockCategory == 1 && car.isclassified == 1 && <button type="button" className='btn btn-default mrg-r10' onClick={() => this.showBumpUpFieldModal('showBumpUpPopup', car, index, car.is_bump_enable)} title={this.props.t('listInventory.bump_up')}><i className="ic-bump-up"></i></button>)}

                                                            {/* {(car.bump_up == "1" || car.is_bump_enable == "1") ? <button type="button" style={{ cursor: "not-allowed" }} className="btn btn-default mrg-r10" onClick={(event) => event.preventDefault()}><i className="ic-bump-up"></i></button> :
                                                                <button type="button" className='btn btn-default mrg-r10' onClick={() => this.showBumpUpFieldModal('showBumpUpPopup', car.id, index, car.is_bump_enable)} title={this.props.t('listInventory.bump_up')}><i className="ic-bump-up"></i></button>} */}
                                                            {(stockCategory == 1 && <div aria-label="First group" role="group" className="btn-group mrg-r10">
                                                                <button type="button" className="btn btn-default" onClick={() => this.showModal('showAddLeadPopup',car.id, index)} title={this.props.t('listInventory.add_lead')}><i className="ic-add"></i></button>
                                                            </div>)}

                                                            <div aria-label="First group" role="group" className="btn-group">
                                                                <button type="button" className="btn btn-default" onClick={() => this.showModal('showSharePopup',car.id, index)} title={this.props.t('listInventory.share_inventory')}><i className="ic-share icons-normal"></i></button>
                                                            </div>
                                                          </div> : 
                                                        ''    
                                                    }    

                                                    {car.car_status == '2'? 
                                                        <div>
                                                            <div aria-label="First group" role="group" className="btn-group mrg-r10">
                                                                <button type="button" className="btn btn-default" onClick={() => this.showModal('showAddToStockPopup',car.id, index)} title={this.props.t('listInventory.add_to_stock')}><i className="ic-add"></i></button>
                                                            </div>
                                                        </div>: ''
                                                    }                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )}
                    </ul>
                </div>

                {this.state.showAddLeadPopup == false ? '' :
                    <ModalPopup id="add_lead" className="modal" title={this.props.t('listInventory.add_buyer_lead')} modalClose={this.closeModal}>
                        <AddBuyerLead handleLeadAdd={(count) => this.props.handleLeadAdd(this.state.currentIndex, count)} modalClose={this.closeModal} carId={this.state.carId} />
                    </ModalPopup>
                }

                {this.state.showCertificationEditPopup == false ? '' :
                    <ModalPopup id="add_lead" className="modal" title={this.props.t('listInventory.edit')} modalClose={this.closeModal}>
                        <CertificationEdit modalClose={this.closeModal} carId={this.state.carId} car_id_hash={this.state.car_id_hash} updateStockData={this.updateListData} currentIndex={this.state.currentIndex} />
                    </ModalPopup>
                }

                {this.state.showAddToStockPopup == false? '':
                    <ModalPopup id="add_to_stock" className="modal" title={this.props.t('listInventory.add_to_stock')} modalClose={this.closeModal}>
                        <AddToStock handleAddToStock={this.handleRemovedCar} modalClose={this.closeModal} carId={this.state.carId} stockType={this.props.stockType} stockCategory={this.state.stockCategory}/>
                    </ModalPopup>
                }                    

                {this.state.showFeaturedPopup == false ? '' :
                    <ModalPopup id="featured_popup" className="modal" title={this.props.t('listInventory.add_feature')} modalClose={this.closeModal}>
                        <MakeFeatured modalClose={this.closeModal} carId={this.state.carId} featuredVal={this.state.featuredVal} classifiedVal={this.state.classifiedVal}   updateStockData={this.updateListData} currentIndex={this.state.currentIndex} />
                    </ModalPopup>
                }

                {this.state.showClassifiedPopup == false ? '' :
                    <ModalPopup id="classified_popup" className="modal" title={this.props.t('listInventory.add_classified')} modalClose={this.closeModal}>
                        {SITE_ID_DURING_CLASSIFIED === true ?
                            <MakeClassified modalClose={this.closeModal} carId={this.state.carId} siteName={site_name} classifiedVal={this.state.classifiedVal} featuredVal={this.state.featuredVal} is_bump_enable={this.state.is_bump_enable} updateStockData={this.updateListData} currentIndex={this.state.currentIndex} getbumpUpStatus={this.getbumpUpStatus} siteid={this.state.siteid} is_bursa_car={this.state.is_bursa}/>
                            :
                            <MakeClassifiedStock modalClose={this.closeModal} carId={this.state.carId} siteName={site_name} classifiedVal={this.state.classifiedVal} featuredVal={this.state.featuredVal} is_bump_enable={this.state.is_bump_enable} updateStockData={this.updateListData} currentIndex={this.state.currentIndex} getbumpUpStatus={this.getbumpUpStatus} siteid={this.state.siteid} is_bursa_car={this.state.is_bursa}/>
                        }
                    </ModalPopup>
                } 

                {this.state.showBursaPopup == false ? '' :
                    <ModalPopup id="bursa_popup" className="modal" title={this.props.t('listInventory.add_bursa')} modalClose={this.closeModal}>
                        <MakeBursa modalClose={this.closeModal} carId={this.state.carId}  bursaVal={this.state.bursaVal} updateStockData={this.updateListData} currentIndex={this.state.currentIndex} getbumpUpStatus={this.getbumpUpStatus} />
                    </ModalPopup>
                } 
               
                {this.state.showDeleteReasonPopup == false ? '' :
                    <ModalPopup id="delete_reason_popup" className="modal" title={this.props.t('listInventory.select_remove_reason',{stock_type:this.props.stockType})} modalClose={this.closeModal}>
                        <DeleteReason handleRemovedCar={this.handleRemovedCar} modalClose={this.closeModal} removeReasonList={this.state.removeReasonList} carId={this.state.carId} stockType={this.props.stockType} placeholder ={this.props.t('listInventory.select_remove_reason',{stock_type:this.props.stockType})}/>
                    </ModalPopup>
                }
                {this.state.showgallerymodal == false ? '' : <ModalPopup id="gallary" className="modal modal-lg" title={this.props.t('listInventory.view_photos')} modalClose={this.closeModal}>
                    <ButtonGroup className="asd" changeTabs={this.changeTabs} btngroup={btngroup}/>
                    {this.state.showViewPhoto && 
                        <Carousel slides={this.state.carouselSlidesData} id="abc" ></Carousel>
                    }
                    {this.state.showRejectedPhoto && 
                        <RejectedCarousel slides={this.state.carouselSlidesRejectedImageData} id="abc" ></RejectedCarousel>
                    }
                    {this.state.showTaggingPhoto && 
                        <TagPhotos slides={this.state.carouselSlidesData} imageTagListDpd={this.state.imageTagListDpd}/>
                    }
                </ModalPopup>
                }
                {this.state.showSharePopup == false ? '' : <ModalPopup id="gallary" className="modal modal-lg" title={this.props.t('listInventory.send_car_detail')} modalClose={this.closeModal}>                    
                    <ShareDetails modalClose={this.closeModal} carId={this.state.carId} />                   
                </ModalPopup>
                }                
                {this.state.showViewHistory == false ? '' :
                    <ModalPopup id="" className="modal ViewHistory" title={this.props.t('viewHistory.view_stock_history')} modalClose={this.closeModal}>
                        <ViewHistory modalClose={this.closeModal} carId={this.state.carId}  />
                    </ModalPopup>
                }
                {this.state.showBumpUpPopup == false ? '' :
                    <ModalPopup id="" className="modal" title={this.props.t('listInventory.bump_up_modal_pop_title_msg')} modalClose={this.closeModal}>
                       <MakeBumpUp modalClose={this.closeModal}  carId={this.state.carId} carOne={this.state.carOne} is_bump_enable={this.state.is_bump_enable} currentIndex={this.state.currentIndex} updateStockData={this.updateListData} getbumpUpStatus={this.getbumpUpStatus}/>
                    </ModalPopup>
                }
            </div>
        )
    }
}
export default withTranslation('inventory')(SearchResult);
